<div *ngIf='screenWidth > 767'>
  <div class="flex"></div>
  <div class="flex-444-px">
    <div class="bmw-profile-content">
      <div class="bmw-user-info-title">Reset Password</div>
      <div *ngIf='!passwordResetLink' class="bmw-forgot-password-note">
        Enter your userId below and we'll send a link to the registered email to reset your password
      </div>
      <label *ngIf='!passwordResetLink'>userId*</label>
      <br>
      <div *ngIf='!passwordResetLink'>
          <!--<input type="text" [(ngModel)]='userId' placeholder="Enter userId" name="userId" id="userId">-->
       
        <form name="form" novalidate>
        <input type="text" [(ngModel)]='userId' placeholder="Enter userId" #userField="ngModel" name="userId" id="userId"  maxlength="60" required >
        <div *ngIf="userField.invalid && (userField.dirty || userField.touched)">
           <small *ngIf='userField.errors.required'>Required</small>
         <!--  <small *ngIf='userField.errors.minlength'>User ID must be at least 5 characters long</small> -->
            <small *ngIf='userField.errors.maxlength'>User ID can be max 60 characters long</small>
          </div>
        </form>

      </div>
      <div *ngIf='passwordResetLink'>
        <label style="margin-top:20px" for="newPassword">New Password</label>
        <!-- <div class="bmw-toggle-password-display pointer" (click)='togglePasswordDisplay()'>
            <span class="strike" *ngIf='!show'></span>
            <i style="font-size: 20px; vertical-align:middle" class="material-icons">remove_red_eye</i>
            <span style="font-weight:bold;" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{show ? "Hide" : "Show"}}</span>
          </div> -->
        <br>
        <input #inputPassword="ngModel" type="password" (input)='checkPasswordStrength()' required name="newPassword" id="newPassword" [(ngModel)]="newPassword">
        <div *ngIf="inputPassword.invalid && (inputPassword.dirty || inputPassword.touched)">
          <small *ngIf='inputPassword.errors?.required'>Required</small>
        </div>
        <br>
        <div id="strength" #strength>
          <ul id="strengthBar">
            <li class="point" [style.background-color]="bar0"></li>
            <li class="point" [style.background-color]="bar1"></li>
            <li class="point" [style.background-color]="bar2"></li>
          </ul>
        </div>
        <div class="bmw-password-policy">
          <ul>
            <li>8 Characters minimum</li>
            <li>1 Lowercase character</li>
            <li>No sequencing</li>
            <li>1-4 Numbers</li>
            <li>Symbol '#' or '$'</li>
          </ul>
        </div>
        <label for="confirmPassword">Confirm Password</label>
        <br>
        <input type="password" name="confirmPassword" (input)='verifyPassword()' id="confirmPassword" [(ngModel)]="confirmPassword">
        <br>
      </div>
      <small>{{errorMessage}}</small>
      <button *ngIf='!passwordResetLink' (click)='sendResetLink()' [disabled]='!userId' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        class="bmw-submit-button" style="padding:7px;margin-top:20px">Send Link</button>
      <button *ngIf='passwordResetLink' [disabled]='!confirmPassword||!newPassword||!matchPwd||checkPasswordStrength() < 3' (click)='resetPassword()' [ngStyle]='{"background-color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        class="bmw-submit-button pointer" style="padding:7px;margin-top:20px">Reset Password</button>
      <button [routerLink]="['/login']" class="bmw-submit-button pointer" style="padding:7px;margin-top:20px;background-color: grey">Back</button>
    </div>
  </div>
  <div class="flex"></div>
</div>

<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <div class="visible-xs">
    <div class="bmw-profile-content bmw-xs">
      <div class="bmw-user-info-title">{{passwordResetLink ? 'Reset Password' : 'Forgot Password'}}</div>
      <div *ngIf='!passwordResetLink' class="bmw-forgot-password-note">
        Enter your userId below and we'll send a link to the registered email to reset your password
      </div>
      <label *ngIf='!passwordResetLink'>UserId*</label>
      <br>
      <input *ngIf='!passwordResetLink' type="text" [(ngModel)]='userId' placeholder="Enter userId" name="userId" id="userId" minlength="8" maxlength="60">
      <div *ngIf='passwordResetLink'>
        <label style="margin-top:50px" for="newPassword">New Password</label>
        <!-- <div class="bmw-toggle-password-display pointer" (click)='togglePasswordDisplay()'>
          <span class="strike" *ngIf='!show'></span>
          <i style="font-size: 20px; vertical-align:middle" class="material-icons">remove_red_eye</i>
          <span style="font-weight:bold;" [ngStyle]='{"color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'>{{show ? "Hide" : "Show"}}</span>
        </div> -->
        <br>
        <input #inputPassword type="password" (input)='checkPasswordStrength()' name="newPassword" id="newPassword" [(ngModel)]="newPassword">
        <br>
        <div id="strength" #strength>
          <ul id="strengthBar">
            <li class="point" [style.background-color]="bar0"></li>
            <li class="point" [style.background-color]="bar1"></li>
            <li class="point" [style.background-color]="bar2"></li>
          </ul>
        </div>
        <div class="bmw-password-policy">
          <ul>
            <li>8 Characters minimum</li>
            <li>1 Lowercase character</li>
            <li>No sequencing</li>
            <li>1-4 Numbers</li>
            <li>Symbol '#' or '$'</li>
          </ul>
        </div>
        <label for="confirmPassword">Confirm Password</label>
        <br>
        <input type="password" name="confirmPassword" (input)='verifyPassword()' id="confirmPassword" [(ngModel)]="confirmPassword">
        <br>
      </div>
      <small>{{errorMessage}}</small>
      <button *ngIf='!passwordResetLink' type='submit' (click)='sendResetLink()' [disabled]='!userId' [ngStyle]='{"background-color": (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        class="bmw-submit-button" style="padding:7px;margin-top:20px">Send Link</button>
      <button *ngIf='passwordResetLink' [disabled]='!confirmPassword||!newPassword||!matchPwd||checkPasswordStrength() < 3' (click)='resetPassword()' [ngStyle]='{"background-color":  (APP_SETTINGS.isMINI === "true") ? "#bf1a22": (APP_SETTINGS.isRollsRoyce === "true") ? "#281432" : "#1c69d4"}'
        class="bmw-submit-button pointer" style="padding:7px;margin-top:20px">Reset Password</button>
      <button [routerLink]="['/login']" class="bmw-submit-button pointer" style="padding:7px;margin-top:20px;background-color: grey">Back</button>
    </div>
    </div>
</div>